import StepThree from "@/components/dashboard/receive/StepThree";

export default function ReceiveStepThree() {
  return <StepThree />;
}
